// extracted by mini-css-extract-plugin
export default {"root":"OneColumnLayout_root__FyqGu","content":"OneColumnLayout_content__kxtxA"};